export const path = "M1 0L6 5L11 0";
export const props = { viewBox: "0 0 12 6" }
